var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('device-layout',[(!_vm.isSmallDevice)?_c('registration-desktop'):_c('registration-mobile'),_vm._v(" "),_c('env')],1)}
var staticRenderFns = []

export { render, staticRenderFns }